// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"b41bc6ae","509":"27f51b2f"}[chunkId] + ".chunk.js";
};